import * as yup from 'yup'

export const getFPEmailSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    email: yup.string().email(__('Invalid email')).required(__('Email is required'))
  })
}

export const getFPAuthenticationSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    verification_code: yup
      .string()
      .min(6, __('Verification code must be 6 characters'))
      .max(6, __('Verification code must be 6 characters'))
      .required(__('Verification code is required'))
  })
}

export const getFPPasswordSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    password: yup
      .string()
      .min(6, __('Password must be at least 6 characters'))
      .matches(/[0-9]/, __('Password must contain at least one number'))
      // .matches(/[0-9]/, __('Password must contain at least one number'))
      // .matches(/[a-z]/, __('Password must contain at least one lowercase letter'))
      // .matches(/[A-Z]/, __('Password must contain at least one uppercase letter'))
      // .matches(/[^A-Za-z0-9]/, __('Password must contain at least one special character'))
      .required(__('Password is required')),
    confirm_password: yup
      .string()
      .oneOf([yup.ref('password')], __('New password and confirmation do not match.'))
      .required(__('Confirm password is required'))
  })
}

export const getForgotPasswordSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    ...getFPEmailSchema(__).fields,
    ...getFPAuthenticationSchema(__).fields,
    ...getFPPasswordSchema(__).fields
  })
}
